import React from 'react';
import HeroSection from '../components/home/HeroSection';
import StatsSection from '../components/home/StatsSection';
import AboutSection from '../components/home/AboutSection';
import AcademicsSection from '../components/home/AcademicsSection';
import FacilitiesSection from '../components/home/FacilitiesSection';
import NewsEventsSection from '../components/home/NewsEventsSection';
import GalleryPreview from '../components/home/GalleryPreview';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CTASection from '../components/home/CTASection';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <StatsSection />
      <AboutSection />
      <AcademicsSection />
      <FacilitiesSection />
      <NewsEventsSection />
      <GalleryPreview />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
};

export default Home;
